<template>
    <div class="editor-box">
        <vue-ueditor-wrap  v-model="formData[dataConfig.key]" :config="ueConfig" @ready="ready"></vue-ueditor-wrap>
    </div>
</template>

<script>
     import VueUeditorWrap from 'vue-ueditor-wrap'
     import publicAPI from '../../api-path/public-api'
    export default {
        name: "ueditor-component",
        props: ['formData', 'dataConfig'],
        components: {
            VueUeditorWrap
        },
        data() {
            return {
                msg:'',
                ueConfig: {
                    autoHeightEnabled: false,
                    autoHeight: false,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    initialFrameHeight: this.dataConfig['Height']?this.dataConfig['Height']:300,
                     serverUrl: 'http://192.168.10.60:9091/ueditor-config',
                    // serverUrl: `${server.layeditPath}/ueditor-config`,
                    UEDITOR_HOME_URL: '../../../static/UEditor/'
                },
                url:'',
                newMatchStrInfoArr:[],
            }
        },
        mounted() {
            this.msg=this.formData[this.dataConfig.key];
        },
        watch: {
            formData: {
                handler(val){
                    let imgHtmlStr = JSON.parse(JSON.stringify(val[this.dataConfig.key]));
                    if(imgHtmlStr==''){ return } //富文本为空
                    let imgPattern = /<img[^>]+>/g;
                    let matchStrArr = imgHtmlStr.match(imgPattern);//获取富文本图片标签
                    if(!matchStrArr){ return }
                    let matchStrInfoArr = matchStrArr.map(item => { //获取富文本标签对象
                        let imgKey2 =  /src=['"]?([^'"]*)['"]?/i.exec(item)?/src=['"]?([^'"]*)['"]?/i.exec(item)[0]:'';
                        let imgKey= imgKey2?imgKey2.slice(5,imgKey2.length-1):'';
                        return {source: item,imgKey};
                    });

                    let arr=  matchStrInfoArr.filter(ite=>{  //获取到 没有替换的图片
                        return ite.imgKey.indexOf('/group1/')==-1 && ite.imgKey!= undefined && ite.imgKey!=''
                    })

                    let getURL='';
                    if(arr.length==0){ return;}
                    this.$http.post(publicAPI.ueditorUpload,{url:arr[0].imgKey}).then(res=>{
                        if(res.status == 200){
                            getURL= res.result.materialUrl;
                            let resultHtmlStr = imgHtmlStr;
                            matchStrInfoArr.forEach((item) => {
                                if( arr[0].source == item.source && item.imgKey!=getURL && item.source.indexOf('/group1/')==-1){
                                    resultHtmlStr = resultHtmlStr.replace(item.imgKey, getURL);
                                }
                            });
                            val[this.dataConfig.key]=resultHtmlStr;
                        }

                    })


                },
                deep:true,
            },
            msg(val) {
                this.formData[this.dataConfig.key] = val;
            },
        },
        computed: {

        },
        methods: {
            imgWebUrl(url){

                this.$http.post(publicAPI.ueditorUpload,{url:url}).then((res)=>{
                    if(res.status == 200){
                        return  res.result.materialUrl;
                    }else {
                        return  url
                    }
                })
            },
            ready () {
                this.msg=this.formData[this.dataConfig.key];
            }
        }
    }
</script>

<style scoped>

</style>
